export const BUILD_NUMBER = '814e68'; export const SEQUENTIAL_BUILD_NUMBER = '1391'; export const PACKAGE_VERSION = '3.3.0';export const SELECTED_THEME = 'smartcr';
